import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import { errMsg } from "@/lib/api";
import { ConsentCheck, LegalLink } from "@/components/Legal";

const FIELDS = [
  ["code", "Aktivasyon kodu", "text", "ABCD-1234-EF56"],
  ["name", "Ad soyad", "text", "Ayşe Yılmaz"],
  ["email", "E-posta", "email", "ogretmen@okul.edu.tr"],
  ["password", "Şifre (en az 8 karakter)", "password", ""],
];

export default function TeacherRegister() {
  const { teacher, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ code: "", name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [terms, setTerms] = useState(false);
  const [kvkk, setKvkk] = useState(false);
  if (teacher) return <Navigate to="/ogretmen/havuzlar" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register({ ...form, accept_terms: terms, accept_kvkk: kvkk });
      navigate("/ogretmen/havuzlar");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[100dvh] flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md space-y-6 fade-in">
        <Link to="/ogretmen/giris" className="inline-flex items-center gap-2 text-slate-400 hover:text-white" data-testid="back-login-link"><ArrowLeft className="h-4 w-4" /> Girişe dön</Link>
        <Logo />
        <h1 className="font-display text-4xl sm:text-5xl font-bold">Öğretmen <span className="neon-text-green">kaydı</span></h1>
        <form onSubmit={submit} className="panel p-6 sm:p-8 space-y-4" data-testid="teacher-register-form">
          {FIELDS.map(([key, label, type, ph]) => (
            <div key={key} className="space-y-1.5">
              <Label htmlFor={`reg-${key}`}>{label}</Label>
              <Input id={`reg-${key}`} type={type} placeholder={ph} value={form[key]} required autoComplete={key === "password" ? "new-password" : key}
                onChange={(e) => setForm({ ...form, [key]: key === "code" ? e.target.value.toUpperCase() : e.target.value })}
                className="h-12 text-base rounded-2xl bg-[#0B0F16]" data-testid={`register-${key}-input`} />
            </div>
          ))}
          {error && <p className="text-red-400 font-semibold" data-testid="register-error">{error}</p>}
          <ConsentCheck checked={terms} onChange={setTerms} testId="register-terms">FChem <LegalLink kind="terms" />'nı okudum ve kabul ediyorum.</ConsentCheck>
          <ConsentCheck checked={kvkk} onChange={setKvkk} testId="register-kvkk">Kişisel verilerimin <LegalLink kind="kvkk" /> kapsamında işlenmesini onaylıyorum.</ConsentCheck>
          <Button type="submit" disabled={busy || !terms || !kvkk} className="w-full h-14 text-lg" data-testid="register-submit-button">Kayıt ol</Button>
        </form>
      </div>
    </div>
  );
}
